<template>
  <div class="per_container">
    <div class="per_con_left">
      <div class="check_all">
        <el-checkbox :indeterminate="config.left.isIndeterminate" v-model="config.left.checkAll" @change="handleCheckAll($event, 'left')">{{ title[0] }}</el-checkbox>
      </div>
      <div class="tree">
        <el-input v-if="isFilter" :placeholder="placeholder" v-angle="filterText" v-model="filterText" style="margin: 8px 0"></el-input>
        <el-tree
          ref="treeLeft"
          :data="treeDataArr"
          :props="defaultProps"
          node-key="id"
          show-checkbox
          :filter-node-method="filterNodeLeft"
          :default-expanded-keys="leftDefaultExpandedKeys"
          :default-checked-keys="leftDefaultCheckedKeys"
          :default-expand-all="defaultExpandAll"
          :check-on-click-node="checkOnClickNode"
          @check-change="handleCheckChange('left')"
        />
      </div>
    </div>
    <div class="operation">
      <el-button type="primary" icon="el-icon-arrow-left" class="mr-8" @click="toLeft()"></el-button>
      <el-button type="primary" icon="el-icon-arrow-right" @click="toRight()"></el-button>
    </div>
    <div class="per_con_right">
      <div class="check_all">
        <el-checkbox :indeterminate="config.right.isIndeterminate" v-model="config.right.checkAll" @change="handleCheckAll($event, 'right')">{{ title[1] }}</el-checkbox>
      </div>
      <div class="tree">
        <el-tree
          ref="treeRight"
          :data="treeDataArr"
          :props="defaultProps"
          node-key="id"
          show-checkbox
          :filter-node-method="filterNodeRight"
          :default-expanded-keys="rightDefaultExpandedKeys"
          :default-checked-keys="rightDefaultCheckedKeys"
          :default-expand-all="defaultExpandAll"
          :check-on-click-node="checkOnClickNode"
          @check-change="handleCheckChange('right')"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    isFilter: {
      // 是否显示搜索框
      type: Boolean,
      default: false,
    },
    title: {
      type: Array,
      default: () => ['全部数据', '已选择数据'],
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'label',
        }
      },
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
    // 是否默认展开所有节点
    defaultExpandAll: {
      type: Boolean,
      default: false,
    },
    // 左边-默认展开的节点
    leftDefaultExpandedKeys: {
      type: Array,
      default: () => [],
    },
    // 左边-默认选中的节点
    leftDefaultCheckedKeys: {
      type: Array,
      default: () => [],
    },
    // 右边-默认展开的节点
    rightDefaultExpandedKeys: {
      type: Array,
      default: () => [],
    },
    // 右边-默认选中的节点
    rightDefaultCheckedKeys: {
      type: Array,
      default: () => [],
    },
    // 是否在点击节点的时候选中节点
    checkOnClickNode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      treeDataArr: [],
      checkedKeys: [],
      halfCheckedKeys: [],
      checkedNodes: [],
      checkedData: [],
      filterText: '',
      config: {
        left: {
          isIndeterminate: false,
          checkAll: false,
          ref: 'treeLeft',
        },
        right: {
          isIndeterminate: false,
          checkAll: false,
          ref: 'treeRight',
        },
      },
    }
  },
  computed: {
    childrenKey() {
      return this.defaultProps.children || 'children'
    },
    labelKey() {
      return this.defaultProps.label || 'label'
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        this.treeDataArr = val || []
        this.$nextTick(() => {
          this.setTreeFilter()
        })
      },
    },
    filterText(val) {
      this.$refs.treeLeft.filter(val)
    },
  },

  methods: {
    setTreeFilter() {
      this.$refs.treeLeft.filter()
      this.$refs.treeRight.filter()
    },
    toLeft() {
      this.checkedKeys = this.$refs.treeRight.getCheckedKeys()
      this.halfCheckedKeys = this.$refs.treeRight.getHalfCheckedKeys()
      this.setTreeDataArr(this.treeDataArr, false)
      this.setTreeFilter()
      // this.$refs.treeLeft.setCheckedKeys(this.checkedKeys)
      this.$refs.treeRight.setCheckedKeys([])
    },
    toRight() {
      this.checkedKeys = this.$refs.treeLeft.getCheckedKeys()
      this.halfCheckedKeys = this.$refs.treeLeft.getHalfCheckedKeys()
      this.setTreeDataArr(this.treeDataArr, true)
      this.setTreeFilter()
      // this.$refs.treeRight.setCheckedKeys(this.checkedKeys)
      this.$refs.treeLeft.setCheckedKeys([])
    },

    filterNodeLeft(value, data) {
      const isNotSelected = !data.selected
      if (!value) return isNotSelected
      return isNotSelected && data.level == 5 && data.name.includes(value)
    },
    filterNodeRight(value, data) {
      const index = this.checkedData.findIndex(ele => ele.id === data.id)
      if (data.selected) {
        if (index === -1 && ((data.chargeObject === 1 && data.level === 5) || (data.chargeObject === 2 && data.level === 2))) this.checkedData.push(data)
      } else {
        if (index !== -1) this.checkedData.splice(index, 1)
      }

      return data.selected
    },

    // 递归设置数据选中状态
    setTreeDataArr(tree, type) {
      const setTree = treeDataArr => {
        treeDataArr.forEach((item, index) => {
          if (this.checkedKeys.includes(item.id)) {
            treeDataArr[index].selected = type
          }
          if (item[this.childrenKey] && item[this.childrenKey].length) {
            setTree(item[this.childrenKey])
            // 判断半选框是否需要移动
            if (this.halfCheckedKeys.includes(item.id)) {
              if (type) {
                treeDataArr[index].selected = type
              } else {
                const target = treeDataArr[index][this.childrenKey].find(it => {
                  return it.selected
                })
                if (!target) {
                  treeDataArr[index].selected = type
                }
              }
            }
          }
        })
      }
      setTree(tree)
    },

    // 勾选树结构时判断是否勾选上面的全选
    handleCheckChange(type) {
      const config = this.config[type]
      this.checkedNodes = this.$refs[config.ref].getCheckedNodes()
      const hasDisabledNode = this.checkDisabled(this.data)
      const [selectedData, noSelectedData] = this.data.reduce(
        (acc, item) => {
          acc[item.selected ? 0 : 1].push(item)
          return acc
        },
        [[], []]
      )
      const parentNodes = this.checkedNodes.filter(item => (item.chargeObject == 2 && item.level === 1) || (item.chargeObject == 1 && item.level === 2))
      if (!this.checkedNodes.length) {
        config.checkAll = false
        config.isIndeterminate = false
        return
      }
      if (!parentNodes.length || (type === 'left' && parentNodes.length !== noSelectedData.length) || (type === 'right' && parentNodes.length !== selectedData.length)) {
        config.checkAll = false
        config.isIndeterminate = true
        return
      }
      config.checkAll = true
      config.isIndeterminate = type === 'left' && hasDisabledNode
    },

    // 判断是否有子节点被禁用
    checkDisabled(nodes) {
      for (let node of nodes) {
        if (node.disabled) {
          return true
        }
        if (node[this.childrenKey] && node[this.childrenKey].length > 0) {
          if (this.checkDisabled(node[this.childrenKey])) {
            return true
          }
        }
      }
      return false
    },

    // 全选
    handleCheckAll(value, type) {
      const keys = value
        ? this.treeDataArr.map(item => {
            return item.id
          })
        : []
      this.$refs[this.config[type].ref].setCheckedKeys(keys, false)
    },

    resetForm() {
      this.checkedKeys = []
      this.halfCheckedKeys = []
      this.checkedNodes = []
      this.config.left.isIndeterminate = false
      this.config.left.checkAll = false
      this.config.right.isIndeterminate = false
      this.config.right.checkAll = false
      const resetData = data => {
        for (let value of data) {
          value.selected = false
          if (value[this.childrenKey] && value[this.childrenKey].length) {
            resetData(value[this.childrenKey])
          }
        }
      }
      resetData(this.treeDataArr)
      this.setTreeFilter()
      this.checkedData = []
      this.$refs.treeLeft.setCheckedKeys([])
      this.$refs.treeRight.setCheckedKeys([])
    },
  },
}
</script>
<style lang="less" scoped>
.per_container {
  width: 100%;
  display: flex;
  height: 594px;
  justify-content: space-between;
  align-items: center;
  .per_con_left,
  .per_con_right {
    width: 45%;
    height: 100%;
    border: 1px solid #e4e7ed;
    box-sizing: border-box;
  }
  .operation {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
    ::v-deep .el-button {
      margin-left: 0;
      margin-bottom: 10px;
    }
    .mr-8 {
      margin-right: 8px;
    }
  }
  .per_con_title {
    height: 42px;
    line-height: 26px;
    border-radius: 8px 8px 0 0;
    padding: 8px;
    align-self: stretch;
    background: #f2f6f9;
    font-size: 16px;
    box-sizing: border-box;
    border: 1px solid #d8d8d8;
    font-weight: 700;
    text-align: left;
  }
  .check_all {
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f5f7fa;
    text-align: left;
    ::v-deep .el-checkbox__label {
      color: #606266;
      font-size: 14px;
    }
  }
  .tree {
    height: calc(100% - 40px);
    overflow: auto;
    padding: 5px 16px 23px;
    ::v-deep .el-tree-node__label {
      color: #606266;
      font-size: 14px;
    }
  }
}
</style>
